// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__3O1pE","image":"image__3D0_u","title":"title__1OrrQ","price":"price__HiBsx","close":"close__2Qj4e","type":"type__3hQ26","name":"name__211e7"};